export const checkClearLang = (language: string) => {
  const listKeyLang = process.env.REACT_APP_LANGUAGE
    ? process.env.REACT_APP_LANGUAGE.split(",")
    : [];
  return !listKeyLang.includes(language);
};

export const truncateText = (text: string, maxLength: number = 20) => {
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength) + "...";
};
